import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TermsConditionsService } from '@core/services/terms-conditions.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-read-only-privacy',
  templateUrl: './read-only-privacy.component.html',
  styleUrls: ['./read-only-privacy.component.scss'],
  imports: [DialogModule, TranslateModule]
})
export class ReadOnlyPrivacyComponent implements OnInit {
  public visible = true;
  public content: string;

  private programIdMap = {
    'obps': 1,
    'cfr': 2,
    'offset': 3,
    'cm': 4
  }


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ReadOnlyPrivacyComponent>,
    private termsConditionsService: TermsConditionsService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getContent();
  }

  close() {
    this.dialogRef.close();
  }

  getContent() {
    this.termsConditionsService.getRegistrationPrivacyPolicy(this.programIdMap[this.data.type]).subscribe(data => {
      if (data) {
        this.content = this.translateService.currentLang === 'en' ? data.contentEn : data.contentFr;
      } else {
        this.content = '';
      }
    })
  }

}
